import {
  BOX_MODAL_FRAME_BUS_ID,
  useBoxLockIframe,
} from '@jusbrasil-web/shared-feature-locker-farol'
import { JsonObject } from 'type-fest'

import { BOX_MODAL_IFRAME_URL } from '../constants'

interface UseBoxModalProps {
  boxOptions?: JsonObject
  featureCode: string
  fromComponent: string
  prefetch?: boolean
}

export const useBoxModal = (props: UseBoxModalProps) => {
  const { prefetch = false, ...rest } = props
  return useBoxLockIframe(
    BOX_MODAL_FRAME_BUS_ID,
    BOX_MODAL_IFRAME_URL,
    {
      appId: 'web-docview',
      boxOptions: {},
      modalType: 'UNIQUE_FEATURE_MODAL',
      ...rest,
    },
    { prefetch }
  )
}
